export enum InvestmentStream {
  CLIMATE_FINANCE = 'ClimateFinance',
  CARBON_MARKET = 'CarbonMarket',
}
